/** 환율 도메인 공통 포맷 유틸. */

/** ISO 문자열 → ko-KR 짧은 일시. null/invalid → '—'. */
export const formatDateTime = (value: string | null | undefined): string => {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('ko-KR', {
    year: '2-digit',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
};

/** 숫자 → 천단위 콤마 (소수 둘째까지, trailing 0 제거). null → '—'. */
export const formatRate = (value: number | null | undefined): string => {
  if (value === null || value === undefined || !Number.isFinite(value)) return '—';
  return value.toLocaleString('ko-KR', { maximumFractionDigits: 4 });
};

/** 조정값 부호 표기 (+12 / -3 / 0). */
export const formatAdjustment = (value: number | null | undefined): string => {
  if (value === null || value === undefined || !Number.isFinite(value)) return '0';
  if (value > 0) return `+${formatRate(value)}`;
  return formatRate(value);
};
